module.exports = __webpack_public_path__ + "img/img008.f8fe07b0.png";